module.exports = __webpack_public_path__ + "img/Venezuela.7aef6083.png";